import React, { useEffect, useState } from "react";
import MetaService from "../../../services/MetaService";
import { IMetaData } from "../../../helpers/types/global";
import Table from "../../../components/Table/Table";
import { Modal } from "antd";
import MetaForm from "./MetaForm";
import DeleteAlert from "../../page-essential/DeleteAlert";
import {
  MsgError,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";

const tableHeaders = [
  {
    id: 1,
    title: "route",
  },
  {
    id: 2,
    title: "title",
  },
];

interface IModal {
  status: boolean;
  id: string;
  type: string;
}

const TabViewMeta = () => {
  const [data, setData] = useState<IMetaData[]>([]);

  const initalModalData: IModal = {
    status: false,
    id: "",
    type: "",
  };
  const [activeModal, setActiveModal] = useState<IModal>(initalModalData);
  console.log(activeModal, "active modal ====>>>");

  const handleModal = (id: string, type: string) => {
    setActiveModal({
      status: true,
      id: id,
      type: type,
    });
  };

  const fetchMeta = async () => {
    try {
      const res = await MetaService.fetchAll("");
      setData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const removeMeta = async (id: string) => {
    try {
      const res = await MetaService.delete(id);
      MsgSuccess(res.data.message);
      fetchMeta();
      setActiveModal(initalModalData);
    } catch (error: any) {
      if (error.response) {
        MsgError(error.response.data.message || "Error while deleting review.");
      }
    }
  };

  const actionProps = {
    handleEdit: (id: string) => {
      handleModal(id, "edit");
    },
    handleDelete: (id: string) => {
      handleModal(id, "delete");
    },
  };
  useEffect(() => {
    fetchMeta();
  }, []);
  return (
    <div>
      <Table
        tableHeaders={tableHeaders}
        tableBody={data}
        actions={actionProps}
      />

      {activeModal.type === "edit" ? (
        <Modal
          title="Edit Modal"
          open={activeModal.status}
          keyboard
          onCancel={() => setActiveModal(initalModalData)}
          footer={null}
        >
          <MetaForm activeItemId={activeModal.id} fetchMeta={fetchMeta} />
        </Modal>
      ) : (
        ""
      )}
      {activeModal.type === "delete" ? (
        <DeleteAlert
          setModalOpen={() => setActiveModal(initalModalData)}
          handleDelete={() => removeMeta(activeModal.id)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default TabViewMeta;
